import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "../modules/auth/components/ProtectedRoute";
import GuestRoute from "../modules/auth/components/GuestRoute";

const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const AdminLayout = lazy(() => import("../pages/admin/layout"));
const AdminLoginPage = lazy(() => import("../pages/admin/login/page"));
const DashboardPage = lazy(() => import("../pages/admin/dashboard/page"));
const OrdersPage = lazy(() => import("../pages/admin/orders/page"));
const EquipmentPage = lazy(() => import("../pages/admin/equipment/page"));
const FinancePage = lazy(() => import("../pages/admin/finance/page"));
const CalendarPage = lazy(() => import("../pages/admin/calendar/page"));
const SchedulePage = lazy(() => import("../pages/admin/schedule/page"));
const SettingsPage = lazy(() => import("../pages/admin/settings/page"));
const AuthCallbackPage = lazy(() => import("../pages/auth/callback/page"));
const AccountLayout = lazy(() => import("../pages/account/layout"));
const AccountOrdersPage = lazy(() => import("../pages/account/orders/page"));
const AccountClaimPage = lazy(() => import("../pages/account/claim/page"));
const VerifyEmailPage = lazy(() => import("../pages/account/verify-email/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallbackPage />,
  },
  {
    path: "/account/verify-email",
    element: <VerifyEmailPage />,
  },
  {
    path: "/account",
    element: <AccountLayout />,
    children: [
      { index: true, element: <Navigate to="orders" replace /> },
      { path: "orders", element: <AccountOrdersPage /> },
      { path: "claim", element: <AccountClaimPage /> },
    ],
  },
  {
    path: "/admin/login",
    element: (
      <GuestRoute adminOnly>
        <AdminLoginPage />
      </GuestRoute>
    ),
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute roles={["staff", "admin"]} requireBranches>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="dashboard" replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "orders", element: <OrdersPage /> },
      { path: "equipment", element: <EquipmentPage /> },
      { path: "finance", element: <FinancePage /> },
      { path: "calendar", element: <CalendarPage /> },
      { path: "schedule", element: <SchedulePage /> },
      { path: "settings", element: <SettingsPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
